exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".egg_3U8lJCjtQDDfPAiJWLBTQC {\n  position: relative;\n\tborder-radius: 50%/60% 60% 40% 40%;\t\n  background-size: cover;\n\tanimation: roll_oziuMn8HAanZAfja3EJDd 2s linear 0s infinite normal;\n}\n\n@keyframes roll_oziuMn8HAanZAfja3EJDd {\n\t0% {transform: rotate(0deg); margin-left:0;}\n\t25% {transform: rotate(90deg); margin-top: 25%}\n  50% {transform: rotate(180deg); margin-top: 0px;}\n\t75% {transform: rotate(270deg); margin-top: 25%;}\n\t100% {transform: rotate(360deg); margin-top: 0;}\n}", ""]);

// Exports
exports.locals = {
	"egg": "egg_3U8lJCjtQDDfPAiJWLBTQC",
	"roll": "roll_oziuMn8HAanZAfja3EJDd"
};